import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountEffects, accountReducer } from 'account-store';
import { AppConfigModule } from 'app-config.module';
import { AuthEffects, authReducer } from 'auth-app-lib';
import { CashierEffects, cashierReducer } from 'cashier-store';
import { CompanyEffects, companyReducer } from 'company-store';
import { NgxPrinterModule } from 'ngx-printer';
import { OrderEffects, orderReducer } from 'order-store';
import { PlanEffects, planReducer } from 'plan-subscription-store';
import { ActionConfirmModalService, UserPlanModule } from 'psc-ng-common';
import { SubscriptionEffects, subscriptionReducer } from 'subscription-store';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavMenuEffects } from './shared/supporting/nav-menu/store/nav-menu.effects';
import * as navMenuReducer from './shared/supporting/nav-menu/store/nav-menu.reducer';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppConfigModule,
    AppRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatSnackBarModule,
    NgxPrinterModule.forRoot({ printOpenWindow: true }),

    StoreModule.forFeature(authReducer.AuthFeatureKey, authReducer.authReducer),
    EffectsModule.forFeature([AuthEffects]),

    StoreModule.forFeature(
      navMenuReducer.NavMenuFeatureKey,
      navMenuReducer.navMenuReducer
    ),
    EffectsModule.forFeature([NavMenuEffects]),

    StoreModule.forFeature(
      accountReducer.AccountFeatureKey,
      accountReducer.accountReducer
    ),
    EffectsModule.forFeature([AccountEffects]),

    StoreModule.forFeature(
      companyReducer.CompanyFeatureKey,
      companyReducer.companyReducer
    ),
    EffectsModule.forFeature([CompanyEffects]),

    StoreModule.forFeature(
      subscriptionReducer.SubscriptionFeatureKey,
      subscriptionReducer.subscriptionReducer
    ),
    EffectsModule.forFeature([SubscriptionEffects]),
    StoreModule.forFeature(planReducer.PlanFeatureKey, planReducer.planReducer),
    EffectsModule.forFeature([PlanEffects]),

    StoreModule.forFeature(
      orderReducer.OrderFeatureKey,
      orderReducer.orderReducer
    ),
    EffectsModule.forFeature([OrderEffects]),
    StoreModule.forFeature(
      cashierReducer.CashierFeatureKey,
      cashierReducer.cashierReducer
    ),
    EffectsModule.forFeature([CashierEffects]),
    UserPlanModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    ScreenTrackingService,
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'R$ ' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    ActionConfirmModalService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
